import types from './portfolioTypes'

const setGroups = (items: []) => ({ type: types.PORTFOLIO_SET_GROUPS, items })
const setStudents = (items: []) => ({ type: types.PORTFOLIO_SET_STUDENTS, items })
const setFiles = (items: []) => ({ type: types.PORTFOLIO_SET_FILES, items })

const portfolioActions = {
    setGroups,
    setStudents,
    setFiles,
}

export default portfolioActions